<script lang="typescript">
    import { onDestroy } from "svelte";
    import PrescriptionButton from "./PrescriptionButton.svelte";
    import { stellestBackgroundImages } from "./childrenSingleLensData.js";
    import { activePromotions, stellestEyeCarePlanDiscount } from "./offers";
    import { Promotion } from "./types";
    import { state } from "./stores.js";

    function* delayGenerator() {
        var idx = 0;
        while (true) {
            yield 200 * idx;
            idx++;
        }
    }

    const delayGen = delayGenerator();

    let bgUrl = stellestBackgroundImages[0].src;

    const addGap = (index) => {
        let idx = index + 1;
        if (idx === Math.ceil(stellestBackgroundImages.length / 2)) {
            return "gap";
        }
    };

    const setBg = (url) => {
        bgUrl = url;
    };

    let promotions = [];
    $: promotions = activePromotions($state);

    onDestroy(() => window.scrollTo(0, 0));
</script>

<svelte:head>
    {#each stellestBackgroundImages as { alt_text, src }}
        <link rel="preload" as="image" href={src} />
    {/each}
</svelte:head>

<section
    class="justify-center h-screen overflow-y-hidden bg-center bg-cover bg-no-repeat stellest-background"
    style="background-image: url('{bgUrl}')"
>
    <div class="min-h-full flex flex-col ">
        <div class="flex w-full align-top text-xl mt-4 text-white">
            <div class="flex flex-grow justify-center">Without Stellest</div>

            <div class="flex flex-grow justify-center">
                With <img class="ml-1 w-44" src="/img/logos/stellest.png" alt="Stellest logo" />
            </div>
        </div>

        <div class="grid grid-cols-2 w-full flex-grow">
            {#if promotions.includes(Promotion.STELLEST_EYECARE_PLAN)}
                <div
                    class="col-start-2 border-0 p-4 mx-20 bg-gray-50 bg-opacity-40  rounded-md self-end"
                >
                    <h2>Features & Benefits</h2>
                    <ul>
                        <li>Interest free, monthly payments over 12 months</li>
                        <li>
                            {stellestEyeCarePlanDiscount($state).toLocaleString(undefined, {
                                style: "percent",
                            })} discount
                        </li>
                        <li>Insurance against breakage/loss</li>
                    </ul>
                </div>
            {/if}
        </div>

        <div class="flex w-full flex-stretch items-end justify-center gap-x-8 pt-10 buttons mb-8">
            {#each stellestBackgroundImages as { alt_text, src }, i}
                <PrescriptionButton
                    transitionParams={{ y: 350, duration: 600, delay: delayGen.next().value }}
                    onClick={() => setBg(src)}
                    isSelected={bgUrl == src}
                    classes={addGap(i)}
                >
                    {@html alt_text}
                </PrescriptionButton>
            {/each}
        </div>
    </div>
</section>

<style>
    .stellest-background {
        transition: opacity 2s ease-in-out;
    }
</style>
